/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2019, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'react',
	'react-dom',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types',
	'../../../../lib/@waca/dashboard-common/dist/ui/Toolbar',
	'../../../../lib/@waca/core-client/js/core-client/ui/KeyCodes'
], function(
	React,
	ReactDOM,
	UI_TOOLKIT,
	PropTypes,
	Toolbar,
	KeyCodes
) {
	const Container = UI_TOOLKIT.Container;
	class ToolbarSectionComponent extends React.Component{
    static ROOT = 'ToolbarSection';
		static propTypes = {
			className: PropTypes.string,
			toolbarSectionDOM: PropTypes.shape({
				setNode: PropTypes.func
			}),
			stateProvider: PropTypes.shape({
				getState: PropTypes.func,
				registerCallback: PropTypes.func,
				removeCallback: PropTypes.func
			}),
			stateEvent: PropTypes.string,
			focusEvent: PropTypes.string
		}
		static defaultProps = {
			focusEvent: 'null_focus'
		};

		constructor(props){
			super(props);
			this._setRef = this._setRef.bind(this);
			this._toolbar = new Toolbar({ className: 'dockedToolbar toolbar', reactToolbar: true });
			this._toolbarRendered = Promise.resolve();
		}

		componentDidMount() {
			this._callbacks = {
				state: this._updateState.bind(this),
				focus: this._focus.bind(this)
			};
			this.props.stateProvider.registerCallback(this.props.stateEvent, this._callbacks['state']);
			this.props.stateProvider.registerCallback(this.props.focusEvent, this._callbacks['focus']);
		}

		componentWillUnmount() {
			this.props.stateProvider.removeCallback(this.props.stateEvent, this._callbacks['state']);
			this.props.stateProvider.removeCallback(this.props.focusEvent, this._callbacks['focus']);
			this._toolbar.clearItems();
		}

		_updateState(state) {
			this._toolbar.clearItems();
			this._toolbarRendered = this._toolbar.addItems(state.actions).then(() => {
				this._toolbar.ready();
			});
		}

		_focus() {
			this._initialFocus = document.activeElement;
			this._toolbarRendered.then(()=>{
				this._toolbar.setFocus();
			});
		}

		_onKeyDown(e) {
			if (e.keyCode === KeyCodes.ESCAPE && this._initialFocus) {
				this._initialFocus.focus();
				this._initialFocus = null;
			}
		}

		_setRef(element){
			this[ToolbarSectionComponent.ROOT] = element;
			/* eslint-disable react/no-find-dom-node */
			const elementDOMNode = ReactDOM.findDOMNode(element);
			/* eslint-disable react/no-find-dom-node */
			this.props.toolbarSectionDOM.setNode(elementDOMNode);

			if (element) {
				elementDOMNode.appendChild(this._toolbar.el);
			} else if (this._toolbar.el.parentNode){
				this._toolbar.el.parentNode.removeChild(this._toolbar.el);
			}
		}

		render(){
			return <Container
				className={ToolbarSectionComponent.ROOT + ' ' + this.props.className}
				ref={this._setRef}
				onKeyDown={this._onKeyDown.bind(this)}
			/>;
		}
	}

	return ToolbarSectionComponent;
});
